import { render, staticRenderFns } from "./SVGIcon.vue?vue&type=template&id=5a48ed15&scoped=true&"
import script from "./SVGIcon.js?vue&type=script&lang=js&"
export * from "./SVGIcon.js?vue&type=script&lang=js&"
import style0 from "./SVGIcon.css?vue&type=style&index=0&id=5a48ed15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48ed15",
  null
  
)

export default component.exports